/* ==========================================================================
   ORD · Offroad Developments — theme.js (vanilla, geen dependencies)
   Modules: header & drawers · predictive search · btw-schakelaar · mijn garage &
   fitment · voertuigzoeker · cart (AJAX + Section Rendering API) · product ·
   collectiefilters · rails · countdown · reveal
   ========================================================================== */
(() => {
  'use strict';

  const ORD = window.ORD || { routes: {}, strings: {} };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* privémodus */ } },
    del(k) { try { localStorage.removeItem(k); } catch (e) { /* privémodus */ } }
  };
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // vertaalde tekst uit layout/theme.liquid (window.ORD.js), met {placeholders}
  const S = (key, vars = {}) => String((ORD.js && ORD.js[key]) || key).replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined ? vars[k] : m));

  /* ---------- geld ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || ORD.money || '€{{amount_with_comma_separator}}';
    const match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const delim = (n, p, t, d) => {
      t = t ?? ','; d = d ?? '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(p);
      const [i, f] = n.split('.');
      return i.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (f ? d + f : '');
    };
    let v = '';
    switch (match && match[1]) {
      case 'amount': v = delim(cents, 2); break;
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      default: v = delim(cents, 2, '.', ',');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.ORD.formatMoney = formatMoney;

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.style.animation = 'none'; void el.offsetWidth; el.style.animation = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------- drawers & modal ---------- */
  let lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    const f = el.querySelector('input, button:not([data-close]), a[href], select') || el.querySelector('button');
    setTimeout(() => f && f.focus({ preventScroll: true }), 60);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .modal.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const close = e.target.closest('[data-close]');
    if (close) closeLayer(close.closest('.drawer, .modal'));
    if (e.target.closest('[data-open-menu]')) openLayer($('[data-menu-drawer]'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      $$('.drawer.is-open, .modal.is-open').forEach(closeLayer);
      $$('[data-mega-item].is-open').forEach(closeMega);
      hidePredictive();
    }
    if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName)) {
      const s = $('#HeaderSearch');
      if (s) { e.preventDefault(); s.focus(); }
    }
  });

  /* ---------- header ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function closeMega(item) {
    item.classList.remove('is-open');
    const t = item.querySelector('[data-mega-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  function openMega(item) {
    $$('[data-mega-item].is-open').forEach((i) => i !== item && closeMega(i));
    item.classList.add('is-open');
    const t = item.querySelector('[data-mega-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  const canHover = window.matchMedia('(hover: hover)').matches;
  $$('[data-mega-item]').forEach((item) => {
    let timer;
    const trigger = item.querySelector('[data-mega-trigger]');
    trigger.addEventListener('click', () => (item.classList.contains('is-open') ? closeMega(item) : openMega(item)));
    if (canHover) {
      item.addEventListener('mouseenter', () => { clearTimeout(timer); timer = setTimeout(() => openMega(item), 90); });
      item.addEventListener('mouseleave', () => { clearTimeout(timer); timer = setTimeout(() => closeMega(item), 160); });
    }
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) closeMega(item); });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-mega-item]') && !e.target.closest('[data-open-vehicle-menu]')) $$('[data-mega-item].is-open').forEach(closeMega);
  });

  // knop die het menu 'Shop per voertuig' openklapt (bv. 'Bekijk het gamma' in de hero)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-open-vehicle-menu]');
    if (!btn) return;
    e.preventDefault();
    const item = $('[data-vehicle-mega]');
    const desktop = window.matchMedia('(min-width: 990px)').matches;
    if (desktop && item) {
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      openMega(item);
      const trigger = item.querySelector('[data-mega-trigger]');
      if (trigger) trigger.focus({ preventScroll: true });
    } else {
      const d = $('[data-vehicle-menu-details]');
      if (d) d.open = true;
      openLayer($('[data-menu-drawer]'));
    }
  });
  $$('[data-vmega]').forEach((vm) => {
    const tabs = $$('[data-vmega-tab]', vm);
    const show = (tab) => {
      tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
      $$('[data-vmega-panel]', vm).forEach((p) => p.classList.toggle('is-active', p.dataset.vmegaPanel === tab.dataset.vmegaTab));
    };
    tabs.forEach((t) => {
      t.addEventListener('click', () => show(t));
      if (canHover) t.addEventListener('mouseenter', () => show(t));
    });
  });

  /* ---------- aankondigingsbalk ---------- */
  $$('[data-announcement]').forEach((wrap) => {
    const slides = $$('.announcement__slide', wrap);
    if (!slides.length) return;
    let i = 0;
    slides[0].classList.add('is-active');
    if (slides.length < 2 || reduceMotion) return;
    setInterval(() => {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, Number(wrap.dataset.interval) || 5000);
  });

  /* ---------- predictive search ---------- */
  const psForm = $('[data-predictive-search]');
  let psAbort;
  function hidePredictive() {
    const r = $('[data-predictive-results]');
    if (r) { r.hidden = true; const i = $('#HeaderSearch'); if (i) i.setAttribute('aria-expanded', 'false'); }
  }
  if (psForm && ORD.routes.predictiveSearch) {
    const input = $('input[type="search"]', psForm);
    const results = $('[data-predictive-results]', psForm);
    const run = debounce(async (q) => {
      if (q.length < 2) { hidePredictive(); return; }
      psAbort && psAbort.abort();
      psAbort = new AbortController();
      try {
        const url = `${ORD.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.sku,vendor,tag&section_id=predictive-search`;
        const res = await fetch(url, { signal: psAbort.signal });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sec = doc.querySelector('#shopify-section-predictive-search') || doc.body;
        results.innerHTML = sec.innerHTML;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        applyFitment(results);
      } catch (err) { if (err.name !== 'AbortError') hidePredictive(); }
    }, 220);
    input.addEventListener('input', () => run(input.value.trim()));
    input.addEventListener('focus', () => { if (input.value.trim().length > 1 && results.innerHTML) results.hidden = false; });
    input.addEventListener('keydown', (e) => {
      const items = $$('.psearch__item', results);
      if (!items.length || results.hidden) return;
      const cur = items.findIndex((i) => i.getAttribute('aria-selected') === 'true');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const next = e.key === 'ArrowDown' ? Math.min(cur + 1, items.length - 1) : Math.max(cur - 1, 0);
        items.forEach((i, n) => i.setAttribute('aria-selected', String(n === next)));
      } else if (e.key === 'Enter' && cur > -1) {
        e.preventDefault();
        window.location.href = items[cur].href;
      }
    });
    document.addEventListener('click', (e) => { if (!psForm.contains(e.target)) hidePredictive(); });
  }

  /* ---------- btw-schakelaar ---------- */
  function setVat(mode) {
    document.body.dataset.vatMode = mode;
    $$('[data-vat]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.vat === mode)));
    store.set('ord:vat', mode);
  }
  if (ORD.vatToggle) {
    setVat(store.get('ord:vat') === 'ex' ? 'ex' : 'inc');
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-vat]');
      if (b) setVat(b.dataset.vat);
    });
  }

  /* ======================================================================
     MIJN GARAGE · voertuigdata, opslag, fitment
     ====================================================================== */
  let VD = { vehicles: [], groups: {}, hub: '/pages/voertuig' };
  try { VD = JSON.parse($('#VehicleData').textContent); } catch (e) { /* geen voertuigdata */ }
  const vehicles = VD.vehicles || [];
  const byId = Object.fromEntries(vehicles.map((v) => [v.id, v]));
  const allVehicleHandles = new Set(vehicles.flatMap((v) => v.cats.map((c) => c.h)));
  const vName = (v) => `${v.brand} ${v.model} ${(v.period || '').split(' · ')[0]}`.trim();
  const vShort = (v) => `${v.model} ${(v.period || '').split(' · ')[0].replace(' – heden', '+').replace(' – ', '–')}`;
  const hubUrl = (v) => `${VD.hub}?v=${encodeURIComponent(v.id)}`;

  const garage = {
    get() { const id = store.get('ord:vehicle'); return id && byId[id] ? byId[id] : null; },
    set(id) {
      if (!byId[id]) return;
      store.set('ord:vehicle', id);
      renderGarage();
      document.dispatchEvent(new CustomEvent('ord:vehicle', { detail: byId[id] }));
    },
    clear() { store.del('ord:vehicle'); renderGarage(); document.dispatchEvent(new CustomEvent('ord:vehicle', { detail: null })); }
  };
  window.ORD.garage = garage;

  function renderGarage() {
    const v = garage.get();
    $$('[data-garage-empty]').forEach((el) => { el.hidden = !!v; });
    $$('[data-garage-filled]').forEach((el) => { el.hidden = !v; });
    $$('[data-garage-name]').forEach((el) => { if (v) { el.textContent = vName(v); el.href = hubUrl(v); } });
    $$('[data-mobile-vehicle-label]').forEach((el) => { el.textContent = v ? vShort(v) : el.dataset.default || el.textContent; });
    $$('[data-garage-short]').forEach((el) => { if (v) el.textContent = vShort(v); });
    $$('[data-garage-help]').forEach((el) => { if (v) el.textContent = S('parts_fit_count', { n: v.cats.reduce((n, c) => n + c.n, 0) }); });
    $$('[data-fit-only-wrap]').forEach((el) => { el.hidden = !v; });
    $$('[data-garage-btn]').forEach((el) => { if (v && el.dataset.labelChange) el.textContent = S('change_vehicle'); });
    applyFitment(document);
    applyCategoryHub(v);
    applyCollectionBanner();
    applyPdpFit();
    renderFinderSaved();
  }

  const svgCheck = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  const svgAlert = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>';

  function fitState(colls, v) {
    if (!v) return null;
    const list = (colls || '').split(' ').filter(Boolean);
    const mine = new Set(v.cats.map((c) => c.h));
    if (list.some((h) => mine.has(h))) return 'yes';
    if (list.some((h) => allVehicleHandles.has(h))) return 'no';
    return null; // universeel
  }

  function applyFitment(root) {
    const v = garage.get();
    $$('[data-card]', root).forEach((card) => {
      const slot = $('[data-fit]', card);
      const state = fitState(card.dataset.colls, v);
      card.dataset.fitState = state || 'universal';
      if (!slot) return;
      if (!state) { slot.hidden = true; slot.innerHTML = ''; return; }
      slot.hidden = false;
      slot.innerHTML = state === 'yes'
        ? `<span class="fit-chip">${svgCheck}${S('fits', { v: vShort(v) })}</span>`
        : `<span class="fit-chip fit-chip--no">${S('fits_not', { v: vShort(v) })}</span>`;
    });
    const only = $('[data-fit-only]');
    if (only && only.checked) filterFitOnly(true);
  }

  // categoriehub: eigen voertuig bovenaan, passende producten eerst
  function applyCategoryHub(v) {
    const rows = $('[data-hub-vehicles]');
    if (rows) {
      $$('.vrow', rows).forEach((r) => r.classList.toggle('is-mine', !!v && r.dataset.vehicle === v.id));
      const mine = v && $(`.vrow[data-vehicle="${CSS.escape(v.id)}"]`, rows);
      if (mine) rows.prepend(mine);
    }
    const grid = $('[data-hub-grid]');
    if (grid && v) {
      const cards = $$('[data-card]', grid);
      const rank = (c) => (c.dataset.fitState === 'yes' ? 0 : c.dataset.fitState === 'no' ? 2 : 1);
      cards.slice().sort((a, b) => rank(a) - rank(b)).forEach((c) => grid.appendChild(c));
    }
  }

  function filterFitOnly(on) {
    $$('[data-product-grid] [data-card]').forEach((c) => { c.style.display = on && c.dataset.fitState === 'no' ? 'none' : ''; });
  }
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-fit-only]')) { store.set('ord:fitonly', e.target.checked ? '1' : ''); filterFitOnly(e.target.checked); }
  });
  $$('[data-fit-only]').forEach((cb) => { cb.checked = store.get('ord:fitonly') === '1'; });

  function applyCollectionBanner() {
    const wrap = $('[data-vehicle-collection]');
    const banner = $('[data-vehicle-banner]');
    if (!wrap || !banner) return;
    const collV = byId[wrap.dataset.vehicleCollection];
    const v = garage.get();
    if (!collV || !v) { banner.hidden = true; return; }
    if (collV.id === v.id) {
      banner.className = 'fit-banner';
      banner.innerHTML = `${svgCheck}<span>${S('page_fits_html', { v: vName(v) })}</span>`;
    } else {
      const here = collV.cats.find((c) => location.pathname.endsWith('/' + c.h));
      const twin = here && v.cats.find((c) => c.t === here.t);
      banner.className = 'fit-banner fit-banner--warn';
      banner.innerHTML = `${svgAlert}<span>${S('page_other_html', { c: vName(collV), v: vShort(v) })}</span>` +
        (twin ? `<a href="${twin.u}">${S('cat_for', { c: twin.t, v: vShort(v) })}</a>` : `<a href="${hubUrl(v)}">${S('show_for', { v: vShort(v) })}</a>`);
    }
    banner.hidden = false;
  }

  function applyPdpFit() {
    const box = $('[data-pdp-fit]');
    const pdp = $('[data-product]');
    if (!box || !pdp) return;
    const v = garage.get();
    const ids = (pdp.dataset.fitIds || '').split(',').filter(Boolean);
    const text = $('[data-pdp-fit-text]', box);
    const cta = $('[data-pdp-fit-cta]', box);
    box.classList.remove('is-ok', 'is-no');
    if (!v || !ids.length) return;
    if (ids.includes(v.id)) {
      box.classList.add('is-ok');
      text.textContent = S('pdp_fits', { v: vName(v) });
      cta.innerHTML = `<button type="button" data-open-vehicle>${S('choose_other')}</button>`;
    } else {
      box.classList.add('is-no');
      text.textContent = S('pdp_not', { v: vName(v) });
      cta.innerHTML = S('pdp_not_cta_html', { url: hubUrl(v), v: vShort(v) });
    }
  }

  /* modal */
  const vModal = $('[data-vehicle-modal]');
  function renderModal(activeBrand) {
    if (!vModal) return;
    const brands = [...new Set(vehicles.map((v) => v.brand))];
    const cur = garage.get();
    const brand = activeBrand || (cur ? cur.brand : brands[0]);
    $('[data-vpick-brands]', vModal).innerHTML = brands.map((b) =>
      `<button type="button" class="chip${b === brand ? ' is-active' : ''}" role="tab" aria-selected="${b === brand}" data-vpick-brand="${b}">${b}</button>`).join('');
    $('[data-vpick-list]', vModal).innerHTML = vehicles.filter((v) => v.brand === brand).map((v) =>
      `<button type="button" class="vpick__item${cur && cur.id === v.id ? ' is-current' : ''}" data-vpick="${v.id}"><strong>${v.model}</strong><span>${v.period}</span><span>${S('parts', { n: v.cats.reduce((n, c) => n + c.n, 0) })}</span></button>`).join('') +
      (cur ? `<button type="button" class="vpick__item" data-vpick-clear><strong>${S('no_vehicle')}</strong><span>${S('no_vehicle_sub')}</span></button>` : '');
  }
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open-vehicle]');
    if (open) { e.preventDefault(); renderModal(); closeLayer($('[data-menu-drawer]')); closeLayer($('[data-cart-drawer]')); openLayer(vModal); return; }
    const b = e.target.closest('[data-vpick-brand]');
    if (b) { renderModal(b.dataset.vpickBrand); return; }
    const pick = e.target.closest('[data-vpick]');
    if (pick) {
      garage.set(pick.dataset.vpick);
      closeLayer(vModal);
      const v = garage.get();
      toast(S('saved', { v: vName(v) }));
      if ($('[data-vehicle-hub]')) showHub(v.id, true);
      return;
    }
    if (e.target.closest('[data-vpick-clear]')) { garage.clear(); closeLayer(vModal); return; }
    const setter = e.target.closest('[data-set-vehicle]');
    if (setter && byId[setter.dataset.setVehicle]) store.set('ord:vehicle', setter.dataset.setVehicle);
  });

  /* voertuigzoeker */
  function renderFinderSaved() {
    $$('[data-finder]').forEach((f) => {
      const v = garage.get();
      const saved = $('[data-finder-saved]', f);
      if (!saved) return;
      saved.hidden = !v;
      if (v) { $('[data-finder-saved-name]', f).textContent = vName(v); $('[data-finder-saved-link]', f).href = hubUrl(v); }
    });
  }
  $$('[data-finder]').forEach((form) => {
    const sb = $('[data-finder-brand]', form);
    const sm = $('[data-finder-model]', form);
    const sc = $('[data-finder-cat]', form);
    const go = $('[data-finder-go]', form);
    const ph = { m: sm.options[0].text, c: sc.options[0].text };
    const brands = [...new Set(vehicles.map((v) => v.brand))];
    sb.insertAdjacentHTML('beforeend', brands.map((b) => `<option>${b}</option>`).join(''));
    const fillModels = () => {
      const list = vehicles.filter((v) => v.brand === sb.value);
      sm.innerHTML = `<option value="">${ph.m}</option>` + list.map((v) => `<option value="${v.id}">${v.model} · ${v.period.split(' · ')[0]}</option>`).join('');
      sm.disabled = !list.length;
      fillCats();
    };
    const fillCats = () => {
      const v = byId[sm.value];
      if (!v) { sc.innerHTML = `<option value="">${ph.c}</option>`; sc.disabled = true; go.disabled = true; return; }
      const groups = {};
      v.cats.forEach((c) => { (groups[c.g] = groups[c.g] || []).push(c); });
      sc.innerHTML = `<option value="">${ph.c} (${v.cats.reduce((n, c) => n + c.n, 0)})</option>` +
        Object.keys(groups).map((g) => `<optgroup label="${(VD.groups && VD.groups[g]) || g}">${groups[g].map((c) => `<option value="${c.u}">${c.t} (${c.n})</option>`).join('')}</optgroup>`).join('');
      sc.disabled = false;
      go.disabled = false;
    };
    sb.addEventListener('change', fillModels);
    sm.addEventListener('change', fillCats);
    form.addEventListener('submit', () => {
      const v = byId[sm.value];
      if (!v) return;
      garage.set(v.id);
      window.location.href = sc.value || hubUrl(v);
    });
    const cur = garage.get();
    if (cur) { sb.value = cur.brand; fillModels(); sm.value = cur.id; fillCats(); }
  });

  /* voertuighub */
  function showHub(id, push) {
    const hub = $('[data-vehicle-hub]');
    if (!hub) return;
    const target = id && $(`[data-hub-panel="${CSS.escape(id)}"]`, hub) ? id : '__all';
    $$('[data-hub-panel]', hub).forEach((p) => {
      p.hidden = p.dataset.hubPanel !== target;
      // lazy-afbeeldingen in een paneel dat verborgen was bij het laden, laadt Chrome niet vanzelf
      if (!p.hidden) $$('img[loading="lazy"]', p).forEach((img) => { img.loading = 'eager'; });
    });
    if (push) history.replaceState(null, '', target === '__all' ? location.pathname : `?v=${target}`);
    if (target !== '__all') {
      const v = byId[target];
      if (v) document.title = `${S('title_parts', { v: vName(v) })} – ${document.title.split('–').pop().trim()}`;
    }
    initRails(hub);
    window.scrollTo({ top: 0 });
  }
  if ($('[data-vehicle-hub]')) {
    const param = new URLSearchParams(location.search).get('v');
    if (param && byId[param]) store.set('ord:vehicle', param);
    showHub(param || (garage.get() && garage.get().id));
  }

  $$('[data-prefill-vehicle]').forEach((i) => { const v = garage.get(); if (v && !i.value) i.value = vName(v); });

  /* ======================================================================
     CART
     ====================================================================== */
  const cartDrawer = $('[data-cart-drawer]');
  function updateCartUI(sections, count) {
    if (sections && sections['cart-drawer']) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const inner = doc.querySelector('#shopify-section-cart-drawer') || doc.body;
      $('#CartDrawerInner').innerHTML = inner.innerHTML;
    }
    if (typeof count === 'number') {
      $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
      $$('[data-cart-count-label]').forEach((el) => { el.textContent = `(${count})`; });
    }
  }
  async function cartFetch(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: ['cart-drawer'], sections_url: location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Er ging iets mis');
    return data;
  }
  async function cartCount() {
    const c = await (await fetch(`${ORD.routes.cart}.js`)).json();
    return c.item_count;
  }
  async function addToCart(items) {
    const data = await cartFetch(`${ORD.routes.cartAdd}.js`, { items });
    updateCartUI(data.sections, await cartCount());
    document.dispatchEvent(new CustomEvent('ord:cart-added', { detail: items }));
    if (ORD.cartType === 'page') { window.location.href = ORD.routes.cart; return; }
    openLayer(cartDrawer);
  }
  async function changeLine(line, quantity) {
    const body = $('[data-cart-body]');
    body && body.classList.add('coll__results', 'is-loading');
    try {
      const data = await cartFetch(`${ORD.routes.cartChange}.js`, { line, quantity });
      updateCartUI(data.sections, data.item_count);
      if ($('[data-cart-page]')) window.location.reload();
    } catch (err) { toast(err.message); body && body.classList.remove('is-loading'); }
  }

  document.addEventListener('click', async (e) => {
    const openCart = e.target.closest('[data-open-cart]');
    if (openCart && cartDrawer && ORD.cartType !== 'page') { e.preventDefault(); openLayer(cartDrawer); return; }

    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.classList.add('is-loading');
      try { await addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1 }]); } catch (err) { toast(err.message); }
      quick.classList.remove('is-loading');
      return;
    }
    const ch = e.target.closest('[data-qty-change]');
    if (ch) {
      e.preventDefault();
      const li = ch.closest('[data-line]');
      if (li) changeLine(Number(li.dataset.line), Math.max(0, Number(ch.dataset.qtyChange)));
      return;
    }
    const copy = e.target.closest('[data-copy]');
    if (copy) {
      const t = copy.dataset.copy;
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(() => toast(S('copied', { c: t }))).catch(() => toast(t));
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-qty-input]')) {
      const li = e.target.closest('[data-line]');
      if (li) changeLine(Number(li.dataset.line), Math.max(0, Number(e.target.value) || 0));
    }
  });

  /* ======================================================================
     PRODUCT
     ====================================================================== */
  $$('[data-product]').forEach((root) => {
    const form = $('[data-product-form]', root);
    const json = $('[data-product-json]');
    const data = json ? JSON.parse(json.textContent) : { variants: [] };
    const idInput = form && $('[data-variant-id]', form);
    const addBtn = form && $('[data-add-to-cart]', form);
    const sectionId = root.dataset.sectionId;

    /* galerij */
    const slides = $('[data-slides]', root);
    const thumbs = $$('[data-thumb]', root);
    const counter = $('[data-gallery-count]', root);
    const goTo = (i) => { if (slides) slides.scrollTo({ left: slides.clientWidth * i, behavior: reduceMotion ? 'auto' : 'smooth' }); };
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    if (slides) {
      slides.addEventListener('scroll', debounce(() => {
        const i = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
        if (counter) counter.textContent = `${i + 1} / ${slides.children.length}`;
      }, 60), { passive: true });
    }

    /* aantal */
    const qty = $('[data-qty]', root);
    $$('[data-qty-step]', root).forEach((b) => b.addEventListener('click', () => {
      qty.value = Math.max(1, (Number(qty.value) || 1) + Number(b.dataset.qtyStep));
    }));

    /* varianten */
    const optionInputs = $$('[data-option]', root);
    async function onVariantChange() {
      const selected = $$('fieldset[data-option-index]', root).map((fs) => {
        const c = $('input:checked', fs);
        const lab = $('[data-option-selected]', fs);
        if (c && lab) lab.textContent = c.value;
        return c ? c.value : null;
      });
      const v = data.variants.find((x) => x.options.every((o, i) => o === selected[i]));
      // beschikbaarheid per optiewaarde markeren
      $$('fieldset[data-option-index]', root).forEach((fs) => {
        const idx = Number(fs.dataset.optionIndex);
        $$('input', fs).forEach((inp) => {
          const opts = selected.slice(); opts[idx] = inp.value;
          const match = data.variants.find((x) => x.options.every((o, i) => o === opts[i]));
          inp.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (!v) {
        addBtn.disabled = true;
        $('[data-add-label]', addBtn).textContent = ORD.strings.unavailable || 'Niet beschikbaar';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      $('[data-add-label]', addBtn).textContent = v.available ? ORD.strings.addToCart : ORD.strings.soldOut;
      const sb = $('[data-sticky-add]'); if (sb) sb.disabled = !v.available;
      history.replaceState(null, '', `${location.pathname}?variant=${v.id}`);
      $$('[data-sku-value]', root).forEach((el) => { el.textContent = v.sku || '–'; });
      const skuWrap = $('[data-sku]', root); if (skuWrap) skuWrap.hidden = !v.sku;
      if (v.media && slides) {
        const idx = $$('.gallery__slide', slides).findIndex((s) => s.dataset.mediaId === String(v.media));
        if (idx > -1) goTo(idx);
      }
      // prijs + voorraad via Section Rendering API (Liquid blijft bron van waarheid)
      try {
        const html = await (await fetch(`${location.pathname}?variant=${v.id}&section_id=${sectionId}`)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['[data-price-wrap]', '[data-stock-wrap]', '[data-sticky-price]'].forEach((sel) => {
          const fresh = doc.querySelector(sel); const cur = document.querySelector(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
      } catch (e) { /* prijs blijft staan */ }
    }
    optionInputs.forEach((i) => i.addEventListener('change', onVariantChange));

    /* toevoegen */
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const err = $('[data-form-error]', root);
        err.hidden = true;
        addBtn.classList.add('is-loading');
        try {
          await addToCart([{ id: Number(idInput.value), quantity: Number(qty.value) || 1 }]);
        } catch (ex) { err.textContent = ex.message; err.hidden = false; }
        addBtn.classList.remove('is-loading');
      });
    }

    /* sticky add-to-cart */
    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    }

    /* recent bekeken */
    try {
      const seen = JSON.parse(store.get('ord:seen') || '[]').filter((h) => h !== location.pathname);
      seen.unshift(location.pathname);
      store.set('ord:seen', JSON.stringify(seen.slice(0, 12)));
    } catch (e) { /* negeer */ }
  });

  /* aanbevelingen */
  $$('[data-recommendations]').forEach(async (sec) => {
    if (sec.children.length && sec.querySelector('[data-card]')) return;
    try {
      const html = await (await fetch(sec.dataset.url)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; initRails(sec); applyFitment(sec); }
    } catch (e) { /* stil falen */ }
  });

  /* ======================================================================
     COLLECTIE · filters & sortering zonder herladen
     ====================================================================== */
  function initCollection() {
    const wrap = $('[data-collection]');
    if (!wrap) return;
    const sectionId = wrap.dataset.sectionId;
    const render = async (url, push = true) => {
      const results = $('[data-results]', wrap);
      results && results.classList.add('is-loading');
      const u = new URL(url, location.origin);
      u.searchParams.set('section_id', sectionId);
      try {
        const html = await (await fetch(u)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-collection]');
        const openIds = $$('.facet', wrap).map((d) => d.open);
        const wasOpen = $('[data-facets]', wrap)?.classList.contains('is-open');
        wrap.innerHTML = fresh.innerHTML;
        $$('.facet', wrap).forEach((d, i) => { if (openIds[i] !== undefined) d.open = openIds[i]; });
        if (wasOpen) $('[data-facets]', wrap).classList.add('is-open');
        u.searchParams.delete('section_id');
        if (push) history.pushState({ ord: 1 }, '', u.pathname + u.search);
        renderGarage();
        $$('[data-fit-only]', wrap).forEach((cb) => { cb.checked = store.get('ord:fitonly') === '1'; });
        if ($('[data-fit-only]', wrap)?.checked) filterFitOnly(true);
        reveal(wrap);
      } catch (e) { window.location.href = url; }
    };
    const formUrl = () => {
      const form = $('[data-facet-form]', wrap);
      const params = new URLSearchParams(form ? new FormData(form) : undefined);
      const sort = $('[data-sort]', wrap);
      if (sort) params.set('sort_by', sort.value);
      for (const [k, v] of [...params.entries()]) if (v === '') params.delete(k);
      return `${location.pathname}?${params.toString()}`;
    };
    wrap.addEventListener('change', debounce((e) => {
      if (e.target.closest('[data-facet-form]') || e.target.matches('[data-sort]')) render(formUrl());
    }, 350));
    wrap.addEventListener('click', (e) => {
      const a = e.target.closest('[data-facet-link]');
      if (a) { e.preventDefault(); render(a.href); return; }
      if (e.target.closest('[data-facets-open]')) $('[data-facets]', wrap).classList.add('is-open');
      if (e.target.closest('[data-facets-close]')) $('[data-facets]', wrap).classList.remove('is-open');
    });
    window.addEventListener('popstate', () => render(location.href, false));
  }
  initCollection();

  /* ======================================================================
     RAILS · tabs · countdown · reveal
     ====================================================================== */
  function initRails(root = document) {
    $$('[data-rail]', root).forEach((rail) => {
      if (rail.dataset.ready) return;
      const track = $('[data-rail-track]', rail);
      if (!track) return;
      rail.dataset.ready = '1';
      const scope = rail.closest('section') || rail;
      const prev = $('[data-rail-prev]', rail) || $('[data-rail-prev]', scope);
      const next = $('[data-rail-next]', rail) || $('[data-rail-next]', scope);
      const bar = $('[data-rail-progress]', rail);
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const p = max > 0 ? track.scrollLeft / max : 1;
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
        if (bar) { const w = Math.max(track.clientWidth / track.scrollWidth, .08); bar.style.width = `${w * 100}%`; bar.style.transform = `translateX(${p * (1 / w - 1) * 100}%)`; }
      };
      const step = () => track.clientWidth * .9;
      prev && prev.addEventListener('click', () => { if (!rail.hidden) track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', () => { if (!rail.hidden) track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', debounce(update, 150));
      update();
    });
  }
  initRails();

  $$('[data-tabs-section]').forEach((sec) => {
    $$('[data-tab]', sec).forEach((tab) => tab.addEventListener('click', () => {
      $$('[data-tab]', sec).forEach((t) => { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', String(t === tab)); });
      $$('[data-tab-panel]', sec).forEach((p) => { p.hidden = p.dataset.tabPanel !== tab.dataset.tab; });
      const panel = $(`[data-tab-panel="${tab.dataset.tab}"]`, sec);
      panel && panel.querySelector('[data-rail-track]')?.dispatchEvent(new Event('scroll'));
    }));
  });

  function parseEnd(s) {
    if (!s) return null;
    const m = String(s).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59);
  }
  $$('[data-countdown]').forEach((cd) => {
    const end = parseEnd(cd.dataset.countdown);
    if (!end) { cd.hidden = true; return; }
    const set = (sel, v) => { const el = $(sel, cd); if (el) el.textContent = String(v).padStart(2, '0'); };
    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      if (diff === 0 && !window.Shopify?.designMode) {
        const sec = cd.closest('[data-halloween-section]');
        if (sec) sec.hidden = true;
      }
      set('[data-d]', Math.floor(diff / 864e5));
      set('[data-h]', Math.floor(diff / 36e5) % 24);
      set('[data-m]', Math.floor(diff / 6e4) % 60);
      set('[data-s]', Math.floor(diff / 1e3) % 60);
    };
    tick();
    setInterval(tick, 1000);
  });

  function reveal(root = document) {
    const els = $$('[data-reveal]:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    els.forEach((e) => io.observe(e));
  }
  reveal();

  /* projecten: hotspots op de buildfoto */
  document.addEventListener('click', (e) => {
    const pin = e.target.closest('[data-spot-pin]');
    $$('[data-spot].is-open').forEach((s) => {
      if (!pin || s !== pin.closest('[data-spot]')) { s.classList.remove('is-open'); $('[data-spot-pin]', s).setAttribute('aria-expanded', 'false'); }
    });
    if (pin) {
      const spot = pin.closest('[data-spot]');
      const open = spot.classList.toggle('is-open');
      pin.setAttribute('aria-expanded', String(open));
    }
  });

  /* themakeuze-editor: secties opnieuw initialiseren */
  document.addEventListener('shopify:section:load', (e) => { initRails(e.target); reveal(e.target); applyFitment(e.target); });

  renderGarage();

  /* ---------------------------------------------------------------- dealerkaart */
  // Leaflet + OpenStreetMap-tegels pas laden als de kaart in beeld komt (donker gemaakt via CSS-filter).
  function initDealerMap() {
    const root = $('[data-dealer-map]');
    if (!root) return;
    const canvas = $('[data-dealer-canvas]', root);
    const items = $$('[data-dealer]', root);
    const pts = items.filter((b) => b.dataset.lat && b.dataset.lng);
    if (!canvas || !pts.length) { if (canvas) canvas.hidden = true; return; }
    const load = () => new Promise((resolve, reject) => {
      if (window.L) return resolve(window.L);
      const css = document.createElement('link');
      css.rel = 'stylesheet'; css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.head.appendChild(css);
      const js = document.createElement('script');
      js.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      js.onload = () => resolve(window.L); js.onerror = reject;
      document.head.appendChild(js);
    });
    const build = (L) => {
      const map = L.map(canvas, { scrollWheelZoom: false, attributionControl: true });
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 18,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      }).addTo(map);
      const markers = new Map();
      pts.forEach((b) => {
        const icon = L.divIcon({ className: '', html: '<span class="dealer-pin"></span>', iconSize: [18, 18], iconAnchor: [9, 9] });
        const m = L.marker([+b.dataset.lat, +b.dataset.lng], { icon, title: $('strong', b).textContent }).addTo(map);
        m.bindPopup(`<strong>${$('strong', b).textContent}</strong>${$('.dealers__addr', b) ? '<br>' + $('.dealers__addr', b).innerHTML : ''}`);
        m.on('click', () => activate(b, false));
        markers.set(b, m);
      });
      const bounds = L.latLngBounds(pts.map((b) => [+b.dataset.lat, +b.dataset.lng]));
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 9 });
      const activate = (b, fly = true) => {
        items.forEach((x) => x.classList.toggle('is-active', x === b));
        const m = markers.get(b);
        if (!m) return;
        if (fly) map.flyTo(m.getLatLng(), 11, { duration: reduceMotion ? 0 : 0.8 });
        m.openPopup();
      };
      items.forEach((b) => b.addEventListener('click', () => activate(b)));
    };
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      io.disconnect();
      load().then(build).catch(() => { canvas.hidden = true; });
    }, { rootMargin: '400px' });
    io.observe(canvas);
  }
  initDealerMap();
})();
